import React from 'react';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

import { DatePickerInputsProps } from 'ha/components/next/DatePicker/types';
import { useIntl } from 'ha/i18n';
import { Grid, units } from '@ha/dsl';

import SearchBarTextField from './SearchBarTextField';

export const useStyles = makeStyles(() => ({
  margin: {
    marginRight: units.rem(0.5),
  },
  grow: {
    flexGrow: 1,
  },
}));

const DateRangePickerInputs: React.FC<DatePickerInputsProps> = ({
  from,
  isFromFocused,
  onFromFocus,
  to,
  isToFocused,
  onToFocus,
}) => {
  const { T } = useIntl();
  const classes = useStyles();

  // to owerwrite behavior in ha/components/next/DatePicker/containers/DateRangePickerInputs
  // that sets label as a value
  const fromDefaultValue = T('Move-in date');
  const toDefaultValue = T('Move-out date');

  return (
    <Grid container wrap="nowrap">
      <SearchBarTextField
        className={cx(classes.margin, classes.grow)}
        inputProps={{ readOnly: true }}
        placeholder={T('Move in')}
        onClick={onFromFocus}
        focused={isFromFocused}
        value={from === fromDefaultValue ? '' : from}
        data-test-locator="Start Date Home Next"
      />
      <SearchBarTextField
        className={classes.grow}
        inputProps={{ readOnly: true }}
        placeholder={T('Move out')}
        onClick={onToFocus}
        focused={isToFocused}
        value={to === toDefaultValue ? '' : to}
        data-test-locator="End Date Home Next"
      />
    </Grid>
  );
};

export default DateRangePickerInputs;
